import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { TitleBar } from "../components/index.js";
import { getTraits } from "../logic/Logic.js";
import * as actions from "../redux/actions/actions.js";

const ListAllTraits = ({}) => {
  const [infos, setInfos] = useState({});

  useEffect(() => {
    listMonsters();
  }, []);

  const listMonsters = async () => {
    const ret = { traits: getTraits() };
    setInfos(ret);
  };

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={"ListAllTraits"}>
      <br></br>

      {infos?.traits?.map((obj) => {
        return (
          <div>
            <label style={{ fontWeight: 900 }}>{obj.name}: </label>
            {obj.description}
            <br></br>
            <br></br>
          </div>
        );
      })}
    </TitleBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
  story: state.Reducer.story,
});

const mapDispatchToProps = (dispatch) => ({
  setStory: (story) => dispatch(actions.setStory(story)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(ListAllTraits);
